import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Icon from "@amzn/meridian/esm/components/icon";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import clipboardTokens from "@amzn/meridian-tokens/base/icon/clipboard";
import flashTokens from "@amzn/meridian-tokens/base/icon/flash";
import chatTokens from "@amzn/meridian-tokens/base/icon/chat";
import { THEME_COLOR } from "../../styles/colors";

const SECTION_ICONS = {
  context: clipboardTokens,
  topics: flashTokens,
  now: chatTokens,
};

const SectionCard = ({ type, title, content }) => {
  const iconTokens = SECTION_ICONS[type] || clipboardTokens;

  return (
    <Column spacing="300">
      <Row spacing="300" alignmentVertical="center">
        <Theme tokens={{ boxBorderRadiusFill: 14 }}>
          <Box type="fill" backgroundColor={THEME_COLOR.MINT_GREEN} width={28} height={28}>
            <Column height="100%" alignmentHorizontal="center" alignmentVertical="center">
              <div style={{ transform: "scale(0.60)" }}>
                <Theme tokens={{ iconColorSecondary: THEME_COLOR.SEAFOAM_GREEN }}>
                  <Icon tokens={iconTokens} color="secondary" />
                </Theme>
              </div>
            </Column>
          </Box>
        </Theme>
        <Text type="h100">{title}</Text>
      </Row>
      <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.MIST_GRAY, boxBorderRadiusOutline: 12 }}>
        <Box type="outline" spacingInset="400">
          <Column spacing="200">
            {Array.isArray(content) ? (
              content.map((item, i) => (
                <Row key={i} spacing="200" alignmentVertical="top">
                  <Theme tokens={{ textColorPrimary: THEME_COLOR.TEAL_GREEN, textH50FontWeight: 700, textH50FontSize: 16 }}>
                    <Text type="h50" color="primary">•</Text>
                  </Theme>
                  <Column spacing="100">
                    {item.heading && <Text type="h50">{item.heading}</Text>}
                    {item.body && <Text type="b200" color="secondary">{item.body}</Text>}
                  </Column>
                </Row>
              ))
            ) : (
              <Text type="b200">
                {content}
              </Text>
            )}
          </Column>
        </Box>
      </Theme>
    </Column>
  );
};

export default SectionCard;
